import React from "react";

import {DishDetailsItem} from "@apps/dish/interfaces";
import classNames from "classnames";

import DishReviews from "@components/DishReviews/DishReviews";
import NomiconIcon from "@components/NomiconIcon";

import styles from "./DishReviewsContainer.scss";

type DishReviewsContainerProps = {
  dish: DishDetailsItem;
  isOpen: boolean;
  onClose: () => void;
};

export default function DishReviewsContainer({
  dish,
  isOpen,
  onClose,
}: DishReviewsContainerProps): JSX.Element {
  return (
    <div className={classNames(styles.container, {[styles.open]: isOpen})}>
      <button className={styles.back} onClick={onClose}>
        <NomiconIcon icon="nomicon-arrow-left" />
        &nbsp;Back
      </button>
      <DishReviews dish={dish} />
    </div>
  );
}
